import moment from 'moment';

// Helper function to find the first parent org with Platform or Channel Partner level using createdAt as reference
export const findPlatformParentOrg = (advertiser) => {
  if (!advertiser) return null;

  // Check if current advertiser is Platform or Channel Partner level
  if (advertiser.level === 'PLATFORM' || advertiser.level === 'CHANNEL_PARTNER') {
    return advertiser;
  }

  // For non-recursive approach, find Platform/Channel Partner level parents and use createdAt to get the first (earliest) one
  if (advertiser.parentOrg && advertiser.parentOrg.length > 0) {
    // Filter parents that have Platform or Channel Partner level
    const eligibleParents = advertiser.parentOrg.filter(
      (parent) => parent.level === 'PLATFORM' || parent.level === 'CHANNEL_PARTNER'
    );

    if (eligibleParents.length > 0) {
      // Sort by createdAt to find the first (latest) eligible parent. The use of createdAt is fragile and may not be reliable but due to the issue of recursion we don't have much option
      const sortedEligibleParents = eligibleParents.sort((a, b) => {
        const dateA = new Date(a.createdAt);
        const dateB = new Date(b.createdAt);
        return dateB - dateA; // Ascending order (latest first)
      });

      return sortedEligibleParents[0];
    }
  }

  // If no Platform/Channel Partner parent found, return null
  return null;
};

// Type to product code mapping
export const typeToProductCodeMap = {
  DISPLAY: 'DIS',
  EXTERNAL: 'EXT',
  VIDEO: 'CTV',
};

// Helper function to check if campaign name has special characters
export const hasSpecialCharacters = (name) => {
  // Check for any character that is not alphanumeric, space, hyphen, or underscore
  return /[^a-zA-Z0-9\s\-_]/.test(name);
};

// Helper function to format campaign name with naming convention
export const formatCampaignName = (record) => {
  const { name, IONumber, productCode, startDate, advertiser, type } = record;

  // Get CPAcronym from advertiser or from Platform parent org
  let CPAcronym = '';
  if (advertiser && advertiser.CPAcronym) {
    CPAcronym = advertiser.CPAcronym;
  } else {
    // Try to get CPAcronym from Platform level parent org
    const platformParent = findPlatformParentOrg(advertiser);
    if (platformParent && platformParent.CPAcronym) {
      // Use the actual CPAcronym field from Platform parent org
      CPAcronym = platformParent.CPAcronym;
    }
  }

  // Format start date as YYMMDD
  const formattedDate = startDate ? moment(startDate).format('YYMMDD') : '';

  // Determine product code - use productCode if exists, otherwise map from type
  let finalProductCode = productCode;
  if (!finalProductCode && type) {
    finalProductCode = typeToProductCodeMap[type] || 'DIS'; // Default to DIS if type not found
  }

  // Build naming convention: IONumber:CPAcronym:name-productCode-startdate YYMMDD
  const firstParts = [];
  if (IONumber) firstParts.push(IONumber);
  if (CPAcronym) firstParts.push(CPAcronym);

  if (advertiser && advertiser.name) firstParts.push(advertiser.name);

  const secondParts = [];
  if (name) secondParts.push(name);
  if (finalProductCode) secondParts.push(finalProductCode);
  if (formattedDate) secondParts.push(formattedDate);

  // Join first parts with : and second parts with -
  let result = firstParts.join(':');
  if (secondParts.length > 0) {
    result += '-' + secondParts.join('-');
  }

  return result;
};
